import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { LINK_REVIEWS_GUIDE } from 'shared/constants/links'
import { uiStore } from 'shared/store/uiStore'
import { ReviewsRoutes } from 'entities/ExportRouters'

export const NewReviewButton = observer(({ className }: { className?: string }) => {
  return (
    <Button
      text='New review page'
      size='medium'
      iconProps={{ icon: 'add' }}
      onClick={() =>
        uiStore.changeRoute({ path: `/${ReviewsRoutes.root}/${ReviewsRoutes.create}` })
      }
      className={className}
    />
  )
})

export const GuideButton = observer(({ className }: { className?: string }) => (
  <Button
    className={className}
    tag={'a'}
    href={LINK_REVIEWS_GUIDE}
    text='Help guide'
    target='_blank'
    rel='noreferrer'
    size='medium'
    contained='secondary'
    iconProps={{ icon: 'info' }}
  />
))
